class LoewFilterToolbar extends HTMLElement {
  connectedCallback() {
    this.desktop = window.matchMedia('(min-width: 981px)');
    this.search = this.closest('dynamic-product-search');
    this.form = this.closest('form');
    this.groups = Array.from(this.querySelectorAll('details'));
    this.committed = new Map(this.groups.map(group => [group, this.snapshot(group)]));
    this.onClick = event => {
      if (!this.desktop.matches) return;
      const action = event.target.closest('[data-loew-filter-apply], [data-loew-filter-clear]');
      const summary = event.target.closest('summary');
      if (action && this.contains(action)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const group = action.closest('details');
        if (action.hasAttribute('data-loew-filter-clear')) {
          this.inputs(group).forEach(input => {
            if (input.type === 'checkbox') input.checked = false;
            else if (input.type === 'range') input.value = input.id.endsWith('-1') ? input.min : input.max;
            else input.value = '';
          });
          this.updateButtons(group);
        } else {
          this.committed.set(group, this.snapshot(group));
          this.closeAll();
          this.search.addEventListener('on:dynamic-product-search:loaded', () => {
            this.search.querySelector('[id="' + group.id + '"] summary')?.focus({ preventScroll: true });
          }, { once: true });
          this.form.requestSubmit();
        }
        return;
      }
      if (!summary || !this.contains(summary)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const group = summary.parentElement;
      const opening = !group.open;
      this.closeAll();
      if (opening) {
        group.open = true;
        this.alignPanel(group);
        this.updateButtons(group);
      }
    };
    this.onOutside = event => {
      if (this.desktop.matches && !this.contains(event.target)) this.closeAll();
    };
    this.onKeydown = event => {
      if (!this.desktop.matches || event.key !== 'Escape') return;
      const group = this.groups.find(item => item.open);
      if (!group) return;
      event.preventDefault();
      this.closeAll();
      group.querySelector('summary').focus({ preventScroll: true });
    };
    this.onChange = event => {
      if (!this.desktop.matches || !event.target.matches('input')) return;
      const group = event.target.closest('details');
      if (!group) return;
      event.stopImmediatePropagation();
      this.updateButtons(group);
    };
    this.onInput = event => {
      if (!this.desktop.matches) return;
      const group = event.target.closest('details');
      if (group) queueMicrotask(() => this.updateButtons(group));
    };
    this.onMedia = () => { this.closeAll(); this.updateMode(); };
    this.onSubmit = () => { if (this.desktop.matches) this.closeAll(); };
    this.addEventListener('click', this.onClick, true);
    this.addEventListener('change', this.onChange, true);
    this.addEventListener('input', this.onInput);
    this.addEventListener('keydown', this.onKeydown);
    document.addEventListener('click', this.onOutside);
    this.desktop.addEventListener('change', this.onMedia);
    this.form.addEventListener('submit', this.onSubmit, true);
    this.updateMode();
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick, true);
    this.removeEventListener('change', this.onChange, true);
    this.removeEventListener('input', this.onInput);
    this.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('click', this.onOutside);
    this.desktop.removeEventListener('change', this.onMedia);
    this.form.removeEventListener('submit', this.onSubmit, true);
  }
  inputs(group) { return Array.from(group.querySelectorAll('input')); }
  snapshot(group) { return this.inputs(group).map(input => ({ checked: input.checked, value: input.value })); }
  updateButtons(group) {
    const before = this.committed.get(group);
    const inputs = this.inputs(group);
    const dirty = inputs.some((input, index) => input.checked !== before[index].checked || input.value !== before[index].value);
    const selected = inputs.some(input => input.type === 'checkbox' ? input.checked : input.name && input.value !== '');
    const apply = group.querySelector('[data-loew-filter-apply]');
    const clear = group.querySelector('[data-loew-filter-clear]');
    if (apply) apply.disabled = !dirty;
    if (clear) clear.disabled = !selected;
  }
  closeAll() {
    this.groups.forEach(group => {
      if (group.open) {
        const before = this.committed.get(group);
        this.inputs(group).forEach((input, index) => {
          input.checked = before[index].checked;
          input.value = before[index].value;
        });
      }
      group.open = false;
    });
    delete this.search.dataset.loewOpenFilter;
    delete this.search.dataset.loewFilterFocusName;
    delete this.search.dataset.loewFilterFocusValue;
  }
  alignPanel(group) {
    const panelWidth = Math.min(280, window.innerWidth - 48);
    group.toggleAttribute('data-align-right', group.getBoundingClientRect().left + panelWidth > window.innerWidth - 24);
  }
  updateMode() {
    this.groups.forEach(group => {
      group.style.removeProperty('height');
      group.style.removeProperty('overflow');
      group.open = !this.desktop.matches && group.hasAttribute('data-mobile-open');
      this.updateButtons(group);
    });
  }
}
if (!customElements.get('loew-filter-toolbar')) customElements.define('loew-filter-toolbar', LoewFilterToolbar);
